import {
  ATTEVENT_LOADING,
  GET_ATTEVENT,
  GET_ATTEVENT_SUCCESS,
  GET_ATTEVENT_FAIL,
  ADD_ATTEVENT_SUCCESS,
  ADD_ATTEVENT_FAIL,
  DELETE_ATTEVENT_SUCCESS,
  DELETE_ATTEVENT_FAIL,
  UPDATE_ATTEVENT_SUCCESS,
  UPDATE_ATTEVENT_FAIL,
  ATTEVENT_RESET
} from "./actionType";

const INIT_STATE = {
  attEvents: [],
  error: {},
};

const AttEvent = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ATTEVENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ATTEVENT:
          return {
            ...state,
            attEvents: action.payload.data,
            isAttEventCreated: false,
            isAttEventSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_ATTEVENT_FAIL:
      switch (action.payload.actionType) {
        case GET_ATTEVENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAttEventCreated: false,
            isAttEventSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_ATTEVENT: {
      return {
        ...state,
        isAttEventCreated: false,
        loading: true,
      };
    }

    case ATTEVENT_LOADING: {
      return {
        ...state,
        isAttEventCreated: false,
        loading: true,
      };
    }

    case ADD_ATTEVENT_SUCCESS:
      return {
        ...state,
        isAttEventCreated: true,
        loading: false,
        attEvents: [action.payload.data, ...state.attEvents],
      };

    case ADD_ATTEVENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_ATTEVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        attEvents: state.attEvents.filter(
          attEvent => attEvent.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_ATTEVENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_ATTEVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        attEvents: state.attEvents.map(attEvent =>
          attEvent.id.toString() === action.payload.data.id.toString() ? { ...attEvent, ...action.payload.data } : attEvent
        ),
      };

    case UPDATE_ATTEVENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ATTEVENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default AttEvent;